import { createClient } from '@vercel/edge-config';

export const vercelEdgeConfigClient = createClient(
  'https://edge-config.vercel.com/ecfg_jzw3wg3c82bicsstshb6aokonddq?token=7576ac8f-20c5-4133-8424-4b320d10f510',
  { cache: 'force-cache' }, // The default setting for this value causes issues in dev mode. This works and I don't know why because their documentation is crap.
);
